// extracted by mini-css-extract-plugin
export default {"overlay":"ProgressBar_overlay__6o5wK","container":"ProgressBar_container__QqegR","message":"ProgressBar_message__8H4Y4","progress":"ProgressBar_progress__y1h-9"};